<header>
    <div class="logo"></div>
</header>
<div class="hidden-header"></div>


<div class="main-container">
    
    <section *ngIf="currentStep === 1" class="main-content centered">
        <div class="title">
            <h1>¡Hola! Te damos la bienvenida.</h1>
            <h4 class="hidden-mobile">Revisa tus órdenes de pago:</h4>
        </div>
        <app-rut-form></app-rut-form>
    </section>

    <section *ngIf="currentStep === 2" class="main-content with-header">
        <app-send-links-header></app-send-links-header>
        <!-- <div class="orders">
            <h4 class="subtitle">Revisa tus órdenes de pago:</h4>
            <ng-container *ngIf="isLoading">
                <app-order></app-order>
                <app-order></app-order>
                <app-order></app-order>
            </ng-container>
            <ng-container *ngIf="!isLoading">
                <ng-container *ngFor="let order of orders">
                    <app-order [order]="order"></app-order>
                </ng-container>
            </ng-container>
        </div> -->
    </section>
</div>


<footer>
    <a class="go-back-btn" (click)="goToMainSite()">
        <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8354 2.39543C12.1693 2.72933 12.1693 3.27068 11.8354 3.60458L4.06905 11.3709H22C22.4722 11.3709 22.855 11.7537 22.855 12.2259C22.855 12.6981 22.4722 13.0809 22 13.0809H4.05929L11.8354 20.857C12.1693 21.1909 12.1693 21.7322 11.8354 22.0661C11.5015 22.4 10.9601 22.4 10.6262 22.0661L1.39544 12.8354C1.22788 12.6678 1.1444 12.448 1.14502 12.2283C1.14502 12.2275 1.14502 12.2267 1.14502 12.2259C1.14502 11.9621 1.2645 11.7262 1.4523 11.5693L10.6262 2.39543C10.9601 2.06153 11.5015 2.06153 11.8354 2.39543Z" fill="#1A4F57"/>
            </svg>
        </div>
        Volver a TotalAbogados.cl
    </a>
</footer>